import chunk from 'lodash/chunk'
import qs from 'qs'
import extractArrayValues from 'helpers/extract-array-values'
import { SORT_BY_PRICE_LOW_TO_HIGH, SORT_OPTION_NAME_QUERY } from './constants'

const NONE = 'none'

export const processProductData = products => chunk(
  products.map(({ attributes: { tireType, ...attributes }}) => ({ tireType, ...extractArrayValues(attributes) })),
  3
)

const getPrice = price =>
  price === NONE ? price : Number(price)

export const getGTMTireLineData = ({ tireLine, brandName } = {}) => {
  try {
    const {
      'product.repositoryId': id,
      startingListPrice: price = NONE,
      productDisplayName: name,
      // tireType: tireType,
      // season: tireSeason,
      // additional props
      position
    } = (tireLine || {})

    return {
      name,
      id,
      price: getPrice(price),
      position: position + 1, // position starts from 1 not from 0 as in javascript array
      brand: brandName,
      category: 'Tires',
      variant: NONE, // TODO check whether we need to pass here anything instead of NONE
      list: 'Brand Details Page',
      dimension2: NONE
    }
  } catch (err) {
    console.log(err)
  }
}

export const getGTMData = ({ records = [], brandName } = {}) => {
  try {
    return records
      .map(({ attributes } = {}, index) => {
        const {
          'product.repositoryId': [id] = [],
          startingListPrice: [price] = [NONE],
          productDisplayName: [name] = []
          // tireType: [tireType] = [],
          // season: [tireSeason] = []
        } = (attributes || {})

        return {
          name,
          id,
          price: getPrice(price),
          brand: brandName,
          category: 'Tires',
          variant: NONE, // TODO check whether we need to pass here anything instead of NONE
          list: 'Brand Details Page',
          position: index + 1,
          dimension2: 'none'
        }
      })
  } catch (err) {
    console.log(err)
  }
}

export const getSelectedValue = sortOptions => {
  const { value } = sortOptions.find(({ selected }) => selected) || {}
  return value || null
}

export const getSorByPriceURLSearchValue = () => {
  if (window.location) {
    const myKeyValues = window.location.search
    const urlParams = new URLSearchParams(myKeyValues)

    if (urlParams.has(SORT_OPTION_NAME_QUERY)) {
      const sortByPriceParamValue = urlParams.get(SORT_OPTION_NAME_QUERY)

      return sortByPriceParamValue
    }

    return null
  }
}

export const getSelectedOptions = (options, value) => {
  const selectedOptions = options.map(option => {
    if (option.value === value) {
      return {
        ...option,
        selected: true
      }
    }
    return {
      ...option,
      selected: false
    }
  })

  return selectedOptions
}

export const updateSortByPrice = (query, value) => {
  const params = qs.parse(query.slice(1))

  params[SORT_OPTION_NAME_QUERY] = value || SORT_BY_PRICE_LOW_TO_HIGH

  return `?${qs.stringify(params)}`
}

export const commaCheckAndFormatPrice = (price) => {
  if (price && price.indexOf(',') > -1) {
    return price.split(',').join('')
  }

  return price
}
